export const withValue = <T, R>(
  value: T | null | undefined,
  cb: { (v: T): R }
): R | undefined => {
  if (value) {
    return cb(value);
  }
};

export function once<A extends any[], R, C>(
  this: C,
  fn: {
    (...a: A): R;
  }
): { (...a: A): R } {
  let result: R;
  let called = false;
  return function (this: C, ...a: A): R {
    if (!called) {
      result = fn.apply(this, a);
      called = true;
    }
    return result;
  };
}
